import 'css-chunksrc/client/scenes/wbs/task/allocationsList/details/group/completion/completionInput/styles.scss';export default {
  "completionInput": "_completionInput_g54ns_1",
  "edition": "_edition_g54ns_7",
  "input": "_input_g54ns_11",
  "text": "_text_g54ns_31"
};